import React from "react";
import { useTranslation } from "react-i18next";

function Home() {
  const { t } = useTranslation();

  return (
    <>
      <div className="geral">
        <p
          style={{
            marginTop: "35px",
            marginLeft: "auto",
            marginRight: "auto",
            width: "30%",
          }}
        >
          {" "}
          {t("ERROR_page_not_found")}
        </p>
      </div>
    </>
  );
}
export default Home;
